<template>
  <div class="container">
    <NavBar :year="year" />
    <section class="schedule">
      <div class="container">
        <ErrorNotice :active.sync="hasError" :message="error" />
        <div class="box" v-show="loading">Loading...</div>
        <div class="card" v-show="!loading">
          <header class="card-header">
            <p class="card-header-title">Presentation Schedule</p>
          </header>
          <div class="card-content">
            <b-tabs v-model="activeTab" v-if="sessions.length">
              <b-tab-item
                v-for="session in sessions"
                :key="session.id"
                :label="sessionLabel(session)"
              >
                <div v-if="session.items.length == 0">
                  <p class="has-text-grey is-italic">
                    No time slots yet reserved for this session. Go to Nueval to
                    book yourself to a session.
                  </p>
                </div>
                <div class="schedule-item-group" v-else>
                  <div class="columns">
                    <div class="column is-offset-2">
                      <div class="schedule-item">
                        <div class="columns is-mobile">
                          <div class="column is-2 is-12-mobile">
                            09:00:00 EDT
                          </div>
                          <div class="column is-6 is-4-widescreen is-12-mobile">
                            Announcements
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <ScheduleItemGroup
                  v-for="item in session.items"
                  :key="item.id"
                  :group="item"
                  :session="session"
                />
              </b-tab-item>
            </b-tabs>
            <div v-else>
              <p>No session available</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ScheduleItemGroup from "@/components/schedule/ScheduleItemGroup.vue";
import ErrorNotice from "@/components/ErrorNotice.vue";
import { mapGetters, mapActions } from "vuex";
import NavBar from "@/components/NavBar.vue";

export default {
  components: {
    ScheduleItemGroup,
    ErrorNotice,
    NavBar
  },
  data() {
    return {
      activeTab: 0,
      loading: false,
      hasError: false,
      error: null,
      year: ""
    };
  },
  methods: {
    ...mapActions(["loadSessions"]),
    sessionLabel(session) {
      return (
        this.$moment(session.date).format("DD MMM YYYY") +
        " (" +
        session.count +
        ")"
      );
    },
    openTodaysTab() {
      this.sessions.forEach((session, sessIndex) => {
        // If session date is same as today
        if (this.$moment(session.date).isSame(new Date(), "day")) {
          this.activeTab = sessIndex;
        }
      });
    }
  },
  mounted() {
    const handleError = () => {
      this.loading = false;
      this.hasError = true;
      this.error = "Session load error, please reload";
    };

    if (this.$route.params.year) {
      this.year = this.$route.params.year;
    } else {
      this.year = this.defaultYear;
    }

    this.hasError = false;
    this.loading = true;
    this.loadSessions(this.year)
      .then(() => {
        this.loading = false;
        this.openTodaysTab();
      })
      .catch(handleError);
  },
  computed: {
    ...mapGetters(["sessions", "defaultYear"])
  }
};
</script>

<style scoped>
.card {
  border-top: 1px solid #dedede;
}
.card-header-title {
  font-size: 12px;
  text-transform: uppercase;
}
</style>
